import $ from 'jquery';
import throttle from 'lodash/throttle';
import debounce from 'lodash/debounce';

class RevealOnScroll {
    constructor(items, thresholdPercent) {
        this.itemsToReveal = items;
        this.browserHeight = window.innerHeight;
        this.revealThresholdPercent = thresholdPercent;
        this.scrollThrottle = throttle(this.calculateCaller, 200).bind(this);
    }

    init() {
        this.hideInitially();
        this.bindEvents();
        // We force an initial check in case the user refreshes mid-page or coming from back button.
        this.calculateCaller();
    }

    bindEvents() {
        window.addEventListener('scroll', this.scrollThrottle);
        window.addEventListener('resize', debounce(() => {
            this.browserHeight = window.innerHeight;
        }), 300);
    }

    hideInitially() {
        this.itemsToReveal.forEach(el => {
            el.classList.add('reveal-item', 'reveal-item--desktop-only');
            el.isRevealed = false;
        });
        this.itemsToReveal[this.itemsToReveal.length - 1].isLastItem = true;
    }

    calculateCaller() {
        this.itemsToReveal.forEach(el => {
            if (el.isRevealed === false) {
                this.calculateIfScrolledTo(el);
            }
        });
    }

    calculateIfScrolledTo(el) {
        if (window.scrollY + this.browserHeight > el.offsetTop) {
            let scrollPercent = (el.getBoundingClientRect().y / this.browserHeight) * 100;
            if (scrollPercent < this.revealThresholdPercent) {
                el.classList.add('reveal-item--is-visible');
                el.isRevealed = true;
                if (el.isLastItem === true) {
                    window.removeEventListener('scroll', this.scrollThrottle);
                }
            }
        }
    }
}

export default RevealOnScroll;

$(() => {
    // Homepage Reveal On Scroll items.

    if ($('#main').length) {
        const revealOnScrollHeadlineWords = new RevealOnScroll(document.querySelectorAll('.scroll-reveal-h1'), 100);
        revealOnScrollHeadlineWords.init();

        const revealOnScrollGenericSelector = new RevealOnScroll(document.querySelectorAll('.fade-up'), 70);
        revealOnScrollGenericSelector.init();

        const revealOnScrollCards = new RevealOnScroll(document.querySelectorAll('.fadecards'), 100);
        revealOnScrollCards.init();

        const revealOnScrollDescription = new RevealOnScroll(document.querySelectorAll('.fadeelement'), 100);
        revealOnScrollDescription.init();
    }
});